import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import bus from '../evbus';
import store from '@/store';
import CacheControl from '@/services/utils/cache-control';
// @ts-ignore
import { version } from '@/../package.json';
import config from '@/config';
import { reConnectWebsocket, disconnectWebsocket } from '@/services/utils/websocket';

class APIBase {
  public api: AxiosInstance;
  public post: typeof Axios.post;
  public get: typeof Axios.get;
  public put: typeof Axios.put;
  public delete: typeof Axios.delete;
  public patch: typeof Axios.patch;
  public getUri: typeof Axios.getUri;

  public config: AxiosRequestConfig = {
    withCredentials: false,
    headers: {
      'app-version':version,
    }
  };

  private cacheControl: CacheControl;

  constructor(baseURL: string) {
    this.config.baseURL = baseURL;
    const api = Axios.create(this.config);

    this.cacheControl = CacheControl.getInstance();
    this.cacheControl.register(api);

    api.interceptors.request.use(this.interceptRequest.bind(api));
    api.interceptors.response.use(
      this.interceptResponse.bind(api),
      this.interceptResponseError.bind(api)
    );
    this.get = api.get.bind(api);
    this.post = api.post.bind(api);
    this.put = api.put.bind(api);
    this.delete = api.delete.bind(api);
    this.patch = api.patch.bind(api);
    this.getUri = api.getUri.bind(api);
    this.api = api;
  }

  interceptRequest(config: any) {
    const {impersonation, authToken} = store.state;
    const impersonationId = impersonation?.id;
    
    config.headers['Authorization'] = authToken;
    if(impersonationId){ 
      config.headers['app-switch-member'] = impersonationId;
    }
    return config;
  }

  interceptResponse(response: any) {
    return Promise.resolve(response);
  }

  interceptResponseError(err: any) {
    bus.emit('request-error', err);
    return Promise.reject(err);
  }

  setAuthToken(token: any) {
    localStorage.setItem('auth-token', token);
    this.api.defaults.headers.common['Authorization'] = token;
    reConnectWebsocket()
    store.commit('authToken', token);
  }

  removeAuthToken() {
    localStorage.removeItem('auth-token');
    this.api.defaults.headers.common['Authorization'] = null;
    disconnectWebsocket();

    store.commit('authToken', null);
  }
}

export default new APIBase(config.api.baseURL);
